import axios from 'axios';

import type {
  IGetOrgMemberNumberStateParams,
  IGetOrgMemberNumberStateQuery,
  IGetOrgMemberNumberStateRequest,
  IGetOrgMemberNumberStateResponse,
  IGetOrgMemberNumberStateResponseV2,
} from '@/app-package';

const getOrgMemberNumberState = async <Q extends IGetOrgMemberNumberStateQuery>(
  params: IGetOrgMemberNumberStateParams,
  query?: Q,
) => {
  const searchParams = new URLSearchParams();
  if (query?.mlsUniqueId) searchParams.set('mlsUniqueId', query.mlsUniqueId);
  if (query?.useV2Logic) searchParams.set('useV2Logic', 'true');

  const url = `/user/org_member_number_state/${params.boardId}/${
    params.number
  }?${searchParams.toString()}`;

  const config: IGetOrgMemberNumberStateRequest = { url, method: 'get' };

  const { data } =
    await axios.request<
      Q extends { useV2Logic: boolean }
        ? IGetOrgMemberNumberStateResponseV2
        : IGetOrgMemberNumberStateResponse
    >(config);

  return data;
};

export default getOrgMemberNumberState;
